var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4647 4.20001H7.53609C6.79899 4.20001 6.20117 4.79598 6.20117 5.53176V13.6326H16.3952V23.7525H24.4647C25.202 23.7525 25.7997 23.1568 25.7997 22.4207V5.53201C25.7998 4.79624 25.2025 4.20027 24.4649 4.20027L24.4647 4.20001Z",
    fill: "url(#paint0_linear_5555_84527)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2002 24.4684C4.2002 25.2046 4.79754 25.8002 5.53511 25.8002H13.9994L13.9992 16.0236H4.20037L4.2002 24.4684Z",
    fill: "url(#paint1_linear_5555_84527)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5555_84527",
    x1: 4.64023,
    y1: 5.63386,
    x2: 25.721,
    y2: 24.8815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D24074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6518B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5555_84527",
    x1: -0.275912,
    y1: 21.0527,
    x2: 9.21896,
    y2: 30.5696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5F6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC371"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection);
export default __webpack_public_path__ + "static/media/Section.d095f41b0008c08ace3c8eb487470fc0.svg";
export { ForwardRef as ReactComponent };